import { Link } from 'react-router-dom';
import type { CategoryRef } from '@nk/shared';
import { categoryIcon, Icon } from '@/components/shell';

/**
 * PRD §8's category cards. Icon and colour come from the CMS row, ordered by the
 * `sort_order` an editor set — the API returns them already sorted, so this renders the
 * list as given rather than imposing an order of its own.
 */
export function CategoryExplorer({ categories }: { categories: CategoryRef[] }) {
  if (categories.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-3.5 sm:grid-cols-4 lg:grid-cols-7">
      {categories.slice(0, 7).map((category) => (
        <Link
          key={category.id}
          to={category.path}
          className="group rounded-lg border border-line bg-white px-2.5 py-5 text-center transition hover:border-red"
          style={{ ['--category-color' as string]: category.color ?? 'var(--red)' }}
        >
          <Icon
            name={categoryIcon(category.icon)}
            size={26}
            className="mx-auto mb-3.5 text-nav-idle transition group-hover:text-[color:var(--category-color)]"
          />
          <span className="text-xs font-bold uppercase tracking-wide text-ink">
            {category.name}
          </span>
        </Link>
      ))}
    </div>
  );
}
